import * as React from 'react';

/**
 * NotFoundPage
 *
 * Simple 404 page component.
 * Renders a message when the user navigates to a route that does not exist.
 */
export const NotFoundPage = (): JSX.Element => {
  return <h1>Page not found</h1>;
};
